export default "__VITE_ASSET__BfWjDMQk__"